import { useState } from "react";
import { authApi, type AppAuthSession } from "../lib/auth-api.js";

interface SiteAuthScreenProps {
  wsUrl: string;
  bootstrapRequired: boolean;
  onAuthenticated(session: AppAuthSession): void;
}

export const SiteAuthScreen = ({
  wsUrl,
  bootstrapRequired,
  onAuthenticated
}: SiteAuthScreenProps) => {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  return (
    <section className="site-access">
      <div className="site-access__card">
        <div className="site-access__hero">
          <div className="site-access__brand">TG</div>
          <h1 className="site-access__title">
            {bootstrapRequired ? "Создайте администратора" : "Войдите"}
          </h1>
          <p className="site-access__subtitle">
            {bootstrapRequired
              ? "Это первый запуск. Создайте логин и пароль — потом сможете подключать Telegram-аккаунты."
              : "Введите логин и пароль."}
          </p>
        </div>

        <form
          className="site-access__form"
          onSubmit={(event) => {
            event.preventDefault();
            const normalizedLogin = login.trim().toLowerCase();
            if (normalizedLogin.length === 0) {
              setError("Введите логин");
              return;
            }
            if (password.length === 0) {
              setError("Введите пароль");
              return;
            }
            if (bootstrapRequired && password !== passwordConfirm) {
              setError("Пароли не совпадают");
              return;
            }

            setPending(true);
            setError(null);
            const task = bootstrapRequired
              ? authApi.bootstrapUser(normalizedLogin, password, wsUrl)
              : authApi.login(normalizedLogin, password, wsUrl);

            void task
              .then((session) => {
                setPassword("");
                setPasswordConfirm("");
                onAuthenticated(session);
              })
              .catch((cause) =>
                setError(cause instanceof Error ? cause.message : "Не удалось выполнить вход")
              )
              .finally(() => setPending(false));
          }}
        >
          <label className="auth-field">
            <span className="auth-field__label">Логин</span>
            <input
              value={login}
              onChange={(event) => setLogin(event.target.value)}
              placeholder="admin"
              autoComplete="username"
              disabled={pending}
            />
          </label>

          <label className="auth-field">
            <span className="auth-field__label">Пароль</span>
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="Минимум 8 символов"
              autoComplete={bootstrapRequired ? "new-password" : "current-password"}
              disabled={pending}
            />
          </label>

          {bootstrapRequired ? (
            <label className="auth-field">
              <span className="auth-field__label">Повторите пароль</span>
              <input
                type="password"
                value={passwordConfirm}
                onChange={(event) => setPasswordConfirm(event.target.value)}
                placeholder="Повторите пароль"
                autoComplete="new-password"
                disabled={pending}
              />
            </label>
          ) : null}

          <div className="site-access__actions">
            <button
              type="submit"
              className="button button--primary"
              disabled={pending}
            >
              {pending
                ? bootstrapRequired
                  ? "Создаём…"
                  : "Входим…"
                : bootstrapRequired
                  ? "Создать"
                  : "Войти"}
            </button>
          </div>
        </form>

        {error ? <div className="side-card__error">{error}</div> : null}
      </div>
    </section>
  );
};
